/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlProcess
 */
export interface ControlProcess {
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    command?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    sha1?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    sha256?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlProcess
     */
    teamId: string;
}

/**
 * Check if a given object implements the ControlProcess interface.
 */
export function instanceOfControlProcess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlProcessFromJSON(json: any): ControlProcess {
    return ControlProcessFromJSONTyped(json, false);
}

export function ControlProcessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlProcess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'command': !exists(json, 'command') ? undefined : json['command'],
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'id': json['id'],
        'sha1': !exists(json, 'sha1') ? undefined : json['sha1'],
        'sha256': !exists(json, 'sha256') ? undefined : json['sha256'],
        'teamId': json['teamId'],
    };
}

export function ControlProcessToJSON(value?: ControlProcess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'command': value.command,
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'id': value.id,
        'sha1': value.sha1,
        'sha256': value.sha256,
        'teamId': value.teamId,
    };
}

